// Port of api/fuel/app/classes/filter/search/games/rules/query/play_winpercent.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'play_winpercent',
	pre: function(rule, config, filter, data, query) {
		query.where('p.user_id', 'in', data.users)
		query.join('play', 'p', 'LEFT JOIN')
		query.leftjoin('p', true)
	},
	field: function() {
		return 'COALESCE(100 * SUM(CASE WHEN p.play_result = 1 THEN p.play_won ELSE 0 END) / NULLIF(SUM(CASE WHEN p.play_result = 1 THEN p.play_count ELSE 0 END), 0), 0)'
	}
})
